<script lang="ts">
    import {totalPrice} from "../stores";
    import Stripe from "../Stripe.svelte";
    import NothingToPay from "./NothingToPay.svelte";

</script>

{#if $totalPrice.amount === 0}
    <NothingToPay />
{:else}
    <Stripe />
{/if}